(function () {
  var directiveId = "alkmapsMap";
  angular
    .module("app")
    .directive(directiveId, ["$rootScope", "$location", "ALKMaps", "$window", "mapService", "UserProvider", "Messages",
      "savedMapInfo", "$timeout",
      function alkmapsMap($rootScope, $location, ALKMaps, $window, mapService, userProvider, Messages, savedMapInfo, $timeout) {
        function link(scope, element, attrs) {
          ALKMaps.APIKey = scope.apikey || "token=" + userProvider.getUser().authToken;

          scope.mapId = attrs.id || "map";
          scope.divId = scope.mapId + "_map";
          scope.urlSync = attrs.urlSync === "true" || false;
          scope.elementWithFocus = false;
          scope.keyboardControl = null;
          scope.navControl = null;

          scope.map = new ALKMaps.Map(scope.divId, { displayProjection: new ALKMaps.Projection("EPSG:4326") });
          var region = userProvider.getUser().region;
          var dataset = userProvider.getUser().dataset;

          var basemap = new ALKMaps.Layer.BaseMap("BaseMap", {
            region: region,
            dataset: dataset
          }, {
            wrapDateLine: true,
            displayInLayerSwitcher: false
          });

          var errorCount = 0;

          var onTileError = function (event) {
            errorCount++;
          };

          var onLoadStart = function (event) {
            errorCount = 0;
          };

          var onLoadEnd = function (event) {

            if (errorCount > 0) {
              errorCount = 0;

              Messages.add("danger", "Please login again.");
              userProvider.clearUser();
              $location.path("/login");
            }
          };

          basemap.events.register("tileerror", basemap, onTileError);
          basemap.events.register("loadstart", basemap, onLoadStart);
          basemap.events.register("loadend", basemap, onLoadEnd);

          scope.map.addLayer(basemap);

          var savedInfo = savedMapInfo.getSavedInfo();

          scope.map.setCenter(savedInfo.mapCenter, savedInfo.mapZoom);

          var c = new ALKMaps.Handler.Click(
            new ALKMaps.Control(), {
              "click": function (e) {
                var ll = scope.map.getLonLatFromPixel(e.xy);
                $rootScope.$broadcast("MapClick", ll);

                if (scope.elementWithFocus !== false) {
                  scope.elementWithFocus.blur();
                }
              }
            }, {
              "single": true
            }
          );
          c.setMap(scope.map);
          c.activate();

          var onMoveEnd = function ( /* e */ ) {
            $timeout(() => {
              updateUrlCenterParameter();
              $rootScope.$broadcast("MapMove");
            });
          };

          scope.map.events.register("moveend", {}, onMoveEnd);

          //Handle disabling of map keyboard tracking for specific input controls
          for (var i = 0; i < scope.map.controls.length; i++) {
            if (scope.map.controls[i].displayClass === "olControlKeyboardDefaults") {
              scope.keyboardControl = scope.map.controls[i];
            } else if (scope.map.controls[i].displayClass === "olControlNavigation") {
              scope.navControl = scope.map.controls[i];
            }
          }

          scope.$on("MapInputFocus", function (event, message) { // jshint ignore:line
            scope.keyboardControl.deactivate();
            scope.elementWithFocus = message;
          });

          scope.$on("MapInputBlur", function ( /*event, message */ ) {
            scope.keyboardControl.activate();
            scope.elementWithFocus = false;
          });

          scope.$on("$destroy", function () {
            mapService.releaseMap(scope.mapId, scope.urlSync);

            basemap.events.unregister("tileerror", basemap, onTileError);
            basemap.events.unregister("loadstart", basemap, onLoadStart);
            basemap.events.unregister("loadend", basemap, onLoadEnd);
            scope.map.events.unregister("moveend", {}, onMoveEnd);
            c.deactivate();

            scope.map = null;
          });

          mapService.initializeMap(scope.map, scope.mapId, !savedInfo.couldTryGeolocating);

          updateUrlCenterParameter();

          function updateUrlCenterParameter() {
            if (scope.urlSync && scope.map) {
              savedMapInfo.saveCurrentInfo(scope.map.getCenter(),
                scope.map.getZoom(), scope.map.style);
              $location.search("center", savedMapInfo.getSavedInfoAsUrl());
            }
          }

        }

        // Usage:
        //
        // Creates:
        //TODO: add attribs for center and zoom
        var directive = {
          link: link,
          restrict: "E",
          scope: {
            apikey: "@"
          },
          template: function (elem, attrs) {
            var divId = attrs.id || "map";
            divId += "_map";
            return "<div id=\"" + divId + "\" tabindex=\"0\"></div>";
          }
        };

        return directive;
      }
    ]);

  angular
    .module("app")
    .directive("alkmapsFocus", ["$timeout", "$parse",
      function alkmapsFocus($timeout, $parse) {
        function link(scope, element, attrs) {
          var model = $parse(attrs.alkmapsFocus);
          scope.$watch(model, function (value) {
            //console.log(value);
            if (value === true) {
              $timeout(function () {
                element[0].focus();
              });
            }
          });
          element.bind("blur", function () {
            //console.log('blur');
            scope.$apply(model.assign(scope, false));
          });
        }

        var directive = {
          link: link,
          //scope: {},
          restrict: "A"
        };

        return directive;
      }
    ]);

  angular
    .module("app")
    .directive("alkmapsNavigation", ["$rootScope", "mapService",
      function alkmapsInput($rootScope, mapService) {
        function link(scope, element, attrs) {
          scope.mapId = attrs.mapId;
          scope.zoomIn = function () {
            mapService.zoomIn(scope.mapId);
          };

          scope.zoomOut = function () {
            mapService.zoomOut(scope.mapId);
          };

          scope.boxZoomState = false;
          scope.toggleBoxZoom = function () {
            scope.boxZoomState = !scope.boxZoomState;
            mapService.boxZoom(scope.boxZoomState, scope.mapId);
          };

          scope.backDisabled = true;
          scope.nextDisabled = true;
          scope.goBack = function () {
            mapService.goBack(scope.mapId);
          };
          scope.goForward = function () {
            mapService.goForward(scope.mapId);
          };

          scope.$on("MapMove", function (event, message) { // jshint ignore:line
            var historyCount = mapService.historyStack();
            if (historyCount.backCount > 1) {
              scope.backDisabled = false;
            } else {
              scope.backDisabled = true;
            }
            if (historyCount.forwardCount > 0) {
              scope.nextDisabled = false;
            } else {
              scope.nextDisabled = true;
            }
          });
        }

        const template = `<div class="map-btns btn-group-vertical">
        <button class="btn btn-default btn-nofocus map-btn zoom-in-btn" ng-click="zoomIn()" title="Zoom In">
          <i class="ico ico-plus"></i>
        </button>
        <button class="btn btn-default btn-nofocus map-btn zoom-out-btn" ng-click="zoomOut()" title="Zoom Out">
          <i class="ico ico-minus"></i>
        </button>
        <button class="btn btn-default btn-nofocus map-btn zoom-box-btn" ng-click="toggleBoxZoom()" 
          title="{{(boxZoomState)?'Drag to Pan':'Drag to Zoom'}}">
          <i class="ico" ng-class="(boxZoomState)?'ico-hand':'ico-box'"></i>
        </button>
       <button class="btn btn-default btn-nofocus map-btn map-prev-btn" ng-click="goBack()" ng-disabled="backDisabled" 
        title="Previous View">
        <i class="ico ico-back"></i>
       </button>
       <button class="btn btn-default btn-nofocus map-btn map-next-btn" ng-click="goForward()" ng-disabled="nextDisabled" 
        title="Next View">
         <i class="ico ico-next"></i>
       </button>
       </div>`

        var directive = {
          link: link,
          restrict: "E",
          scope: {},
          template
        };

        return directive;
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/map/alkmaps.directive.js